import { render } from "./Quiz.vue?vue&type=template&id=34bac10c&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=34bac10c&scoped=true&lang=css"

import exportComponent from "C:\\M1\\projects__gitlab\\comed-station-4-energy-management--tablet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bac10c"]])

export default __exports__